import CopyToClipboard from 'react-copy-to-clipboard';
import { IconButton, IconButtonProps } from '@mui/material';
import { COLOR_ACCENT, COLOR_PRIMARY, COLOR_SECONDARY } from 'shared/config';
import { getToastMessage } from 'shared/lib';
import { Icons } from 'shared/ui';

interface CopyButtonProps extends IconButtonProps {
  text: string;
  successText?: string;
}

export const CopyButton = ({ text, successText, sx, ...props }: CopyButtonProps) => {
  return (
    <CopyToClipboard onCopy={() => getToastMessage('success', successText || 'Сoppied')} text={text}>
      <IconButton className="transparent" sx={{ '&:disabled': { backgroundColor: 'inherit' } }} {...props}>
        <Icons.Copy
          sx={{
            color: COLOR_SECONDARY,
            '&:hover': { color: COLOR_PRIMARY },
            '&:active': { color: COLOR_ACCENT },
            ...sx,
          }}
        />
      </IconButton>
    </CopyToClipboard>
  );
};
